import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
const clockwiseIcon = '<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M256 64c48.9 0 93.6 18.3 127.5 48.5l-32.9 32.9L328 168l22.6 22.6L352 192h96 32V160 64l-1.4-1.4L456 40 433.4 62.6 406.2 89.8C366.5 53.9 313.8 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c86.4 0 161.4-49 198.8-120.6l-28.4-14.8C394.3 406.1 330.1 448 256 448C150 448 64 362 64 256S150 64 256 64zm192 96H381.3L448 93.3V160z"/></svg>'
const antiClockwiseIcon = '<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M256 64c-48.9 0-93.6 18.3-127.5 48.5l32.9 32.9L184 168l-22.6 22.6L160 192H64 32V160 64l1.4-1.4L56 40 78.6 62.6l27.2 27.2C145.5 53.9 198.2 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-86.4 0-161.4-49-198.8-120.6l28.4-14.8C117.7 406.1 181.9 448 256 448c106 0 192-86 192-192s-86-192-192-192zM64 160h66.7L64 93.3V160z"/></svg>'

export function createRotateImageButton(editor) {
    editor.ui.componentFactory.add('rotateImageClockwise', locale => {
        const buttonView = new ButtonView(locale);

        buttonView.set({
            label: trans('client.journal_image_rotate_clockwise'),
            tooltip: true,
            icon: clockwiseIcon
        });

        buttonView.on('execute', () => {
            editor.execute('rotateImage', 90);
            editor.editing.view.focus();
        });

        return buttonView;
    });

    editor.ui.componentFactory.add('rotateImageAnticlockwise', locale => {
        const buttonView = new ButtonView(locale);

        buttonView.set({
            label: trans('client.journal_image_rotate_anticlockwise'),
            tooltip: true,
            icon: antiClockwiseIcon
        });

        buttonView.on('execute', () => {
            editor.execute('rotateImage', -90);
            editor.editing.view.focus();
        });

        return buttonView;
    });
}
